import styled from "styled-components/macro";

export const LoadingSpinnerContainer = styled.div`
  left: 50%;
  top: 20%;
  margin-left: -4em;
  position: absolute;
`;
